export const poppinFormBodySet = body => ({
  type: 'POPPIN_FORM_BODY_SET', body
});

export const poppinFormClose = () => ({
  type: 'POPPIN_FORM_CLOSE'
});

export const poppinFormOpen = (pageId, posX, posY, body) => ({
  type: 'POPPIN_FORM_OPEN', pageId, posX, posY, body
});
